'use client'

import { CheckCircle2, Shield, Sparkles, Target } from 'lucide-react'
import { motion } from 'motion/react'

import { talentPoolCopy } from '@/app/talent-pool/copy'

const PERK_ICONS = [Target, Sparkles, Shield, CheckCircle2] as const

export function TalentPoolPerksSection() {
  const copy = talentPoolCopy
  const [firstWord, ...restWords] = copy.landing.perksTitle.split(' ')
  const restTitle = restWords.join(' ')

  return (
    <section className="pb-14">
      <div className="rounded-3xl border border-border-primary bg-white dark:bg-card px-5 py-10 sm:px-8">
        <div className="mx-auto flex w-full max-w-[664px] flex-col items-center gap-4 text-center">
          <div className="rounded-full border-[1.5px] border-surface-primary bg-white dark:bg-card px-3 py-2 text-sm text-text-body">
            Keuntungan
          </div>
          <h2 className="text-[32px] font-medium leading-[40px] tracking-[-0.02em] text-text-heading md:text-[48px] md:leading-[60px] md:tracking-[-0.04em]">
            <span className="inline-flex items-center bg-status-warning-bg px-1">
              {firstWord}
            </span>{' '}
            {restTitle || firstWord}
          </h2>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {copy.landing.perks.map((perk, index) => {
            const Icon = PERK_ICONS[index % PERK_ICONS.length]!
            return (
              <motion.article
                key={perk.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-50px' }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className="group rounded-2xl border border-border-primary bg-gradient-to-br from-white to-gray-50 dark:from-card dark:to-gray-900 p-6 transition-all hover:shadow-md hover:-translate-y-1"
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-primary/10 text-brand-primary transition-transform group-hover:scale-110">
                  <Icon className="h-6 w-6" />
                </span>
                <p className="mt-4 text-[18px] font-medium leading-[28px] tracking-[-0.02em] text-text-heading md:text-[20px] md:leading-[30px]">
                  {perk.title}
                </p>
                <p className="mt-2 text-[14px] leading-[22px] text-text-muted md:text-[15px] md:leading-[24px]">
                  {perk.description}
                </p>
              </motion.article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
